import { useState } from "react";
import Sidebar from "./Sidebar";

export default function SidebarDrawer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="apn-sidebar-fab"
        aria-label="Sidebar öffnen"
        onClick={() => setOpen(true)}
      >
        ☰ Menü
      </button>
      {open && (
        <div className="apn-sidebar-overlay" role="dialog" aria-modal="true" aria-label="Seitenmenü">
          <div className="apn-sidebar-drawer">
            <div className="apn-sidebar-drawer-head">
              <div>Mitglieder-Menü</div>
              <button aria-label="Schließen" onClick={() => setOpen(false)}>✕</button>
            </div>
            <Sidebar />
          </div>
          <div className="apn-sidebar-backdrop" onClick={() => setOpen(false)} />
        </div>
      )}
    </>
  );
}
